import Vue from 'vue'
import app from './app.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import VueGtag from "vue-gtag";


Vue.config.productionTip = false


import Vuetify from 'vuetify/lib';
Vue.use(Vuetify);


if (document.location.hostname.indexOf("blitoolanddie.com") != -1) {
  /* Production - Use Google Analytics Code */
  Vue.use(VueGtag, 
    {
      config: { 
        id: "UA-85896526-2",
        params: {
          
        }
      }
    },
    router
  );
} else {
  Vue.use(VueGtag, 
    {
      config: { 
        id: "UA-85896526-2",
        params: {
          
        }
      },
      enabled: false
    },
    router
  );
}

new Vue({
  vuetify,
  router:router,
  render: h => h(app),
}).$mount('#app')
